import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userService } from "../../../services/userService";
import type { UserInfo } from "../../../types";

export const useDeleteUser = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId }: { userId: string }) => {
      const deleted = await userService.delete(userId);
      return { deleted, userId };
    },
    onSuccess: ({ deleted, userId }) => {
      if (deleted) {
        qc.setQueryData<UserInfo[]>(["users"], (current = []) => {
          return current.filter((user) => {
            return user.id !== userId;
          });
        });
      }
      qc.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
